export const BLOQUEIO_MANUAL_DTO = [
  {
    "numeroDocumento": "9012205400026256",
    "sequencial": "4",
    "dataBloqueio": "2023-05-17",
    "valorBloqueado": 0.01,
    "processo": "2216",
    "cpfResponsavel": "770484157",
    "motivoBloqueio": "OUTROS",
    "observacao": "teste"
  },
  {
    "numeroDocumento": "9012205400026256",
    "sequencial": "3",
    "dataBloqueio": "2023-05-17",
    "valorBloqueado": 0.01,
    "processo": "2216",
    "cpfResponsavel": "5444293",
    "motivoBloqueio": "OUTROS",
    "observacao": "teste"
  },
  {
    "numeroDocumento": "9012205400026256",
    "sequencial": "2",
    "dataBloqueio": "2023-05-17",
    "valorBloqueado": 0.01,
    "processo": "2216",
    "cpfResponsavel": "5444293",
    "motivoBloqueio": "OUTROS",
    "observacao": "teste"
  },
  {
    "numeroDocumento": "9012205400026256",
    "sequencial": "1",
    "dataBloqueio": "2023-04-11",
    "valorBloqueado": 50,
    "processo": "2216",
    "cpfResponsavel": "492437723",
    "motivoBloqueio": "RESTITUIÇÃO/COMPENSAÇÃO MANUAL",
    "observacao": "Cenário de Teste - Documento numerado de interesse do Fiscel com valor reservado pelo SCC/Sief Processo."
  },
  {
    "numeroDocumento": "7171808685799073",
    "sequencial": "4",
    "dataBloqueio": "2025-06-06",
    "valorBloqueado": 10,
    "processo": "10880412494201217",
    "cpfResponsavel": "988643357",
    "motivoBloqueio": "OUTROS",
    "observacao": null
  },
  {
    "numeroDocumento": "7171808685799073",
    "sequencial": "3",
    "dataBloqueio": "2025-06-06",
    "valorBloqueado": 1,
    "processo": "10880412494201217",
    "cpfResponsavel": "988643357",
    "motivoBloqueio": "OUTROS",
    "observacao": null
  },
  {
    "numeroDocumento": "7171808685799073",
    "sequencial": "2",
    "dataBloqueio": "2025-06-06",
    "valorBloqueado": 0.01,
    "processo": "10880412494201217",
    "cpfResponsavel": "988643357",
    "motivoBloqueio": "OUTROS",
    "observacao": null
  }
]